module.exports = __webpack_public_path__ + "static/media/logo-licitar-digital.ee0afef0.png";